import { Link } from "react-router-dom";

const base =
  "inline-flex items-center justify-center gap-2 rounded-full font-semibold text-sm tracking-tight transition-all duration-300 px-7 py-3.5 select-none";

const variants = {
  primary:
    "bg-[var(--mint)] text-[var(--charcoal)] hover:bg-[var(--ember-deep)] hover:-translate-y-0.5",
  ghostDark:
    "border border-white/40 text-white hover:bg-white hover:text-[var(--ink)] hover:-translate-y-0.5",
  secondary:
    "border border-[var(--ink)] text-[var(--ink)] hover:bg-[var(--ink)] hover:text-[var(--bg-base)] hover:-translate-y-0.5",
  secondaryDark:
    "border border-[var(--dark-text)]/40 text-[var(--dark-text)] hover:bg-[var(--dark-text)] hover:text-[var(--ink)] hover:-translate-y-0.5",
};

export const Button = ({
  children,
  variant = "primary",
  to,
  href,
  className = "",
  ...rest
}) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to)
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );
  if (href)
    return (
      <a href={href} className={cls} {...rest}>
        {children}
      </a>
    );
  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
};
